<template>
  <div class="content-area" style="background-color: white;">
    <div id="cards" class="w-100">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2" v-for="sistema in sistemas" v-if="sistema.TipoSistema.TipoSistemaId == 1" :key="sistema.SistemaId">
        <router-link v-if="sistema.RutaDeAcceso != null && sistema.RutaDeAcceso.includes('http') == false" :to="sistema.RutaDeAcceso">
          <h1>{{sistema.Abreviatura}}</h1>
          <h2>{{sistema.Nombre}}</h2>
          <span>{{sistema.Descripcion}}</span>
        </router-link>
        <a v-else-if="sistema.RutaDeAcceso != null" :href="sistema.RutaDeAcceso" target="_blank">
          <h1>{{sistema.Abreviatura}}</h1>
          <h2>{{sistema.Nombre}}</h2>
          <span>{{sistema.Descripcion}}</span>
        </a>
        <div v-else>
          <h1>{{sistema.Abreviatura}}</h1>
          <h2>{{sistema.Nombre}}</h2>
          <span>{{sistema.Descripcion}}</span>
        </div>
      </div>

      <!--Esto tiene que eliminarse en cuanto se aplique lo de las cuentas-->
      <!--<router-link to="/TemisCivil">
    <h1>EQ</h1>
    <h2>EQUITAS</h2>
  </router-link>-->
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'

  export default {
    computed: {
      sistemas() {
        return this.$store.state.Login_Usuario.Sistemas;
      }
    }
  }
</script>

<style scoped>
  #cards {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 20px;
  }

    #cards h1 {
      font-size: 30px;
      font-weight: bold;
      background: linear-gradient(#007573, #007573);
      width: 120px;
      height: 120px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .5s;
      color: white;
    }

    #cards h2 {
      margin-top: 10px;
      font-size: 20px;
      width: 100%;
    }

    #cards span {
      display: none;
      padding-top: 5px;
      padding-bottom: 5px;
      border: 1px solid #757575;
      border: 1px solid #007573;
      background-color: #757575;
      background-color: rgb(0,117,115);
      color: white;
      font-size: 0.8rem;
    }

    /*Encargado de cargar las ventanas que no tienen redireccionamiento*/
    #cards div div {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
      color:  rgba(255,255,255,0.2);;
      width: 100%;
      /* border: 1px solid #222222; */
      padding-top: 10px;
      position: relative;
      cursor: not-allowed;
    }

      #cards div div:hover {
        text-decoration: none;
        background-color: rgba(0,117,115,0.9);
        background-color: rgba(255,255,255,0.2);
        border: 1px solid #AAA;
        box-sizing: border-box;
      }

        #cards div div:hover span {
          display: block;
          position: absolute;
          left: 0;
          right: 0;
          top: 53%;
        }

    /*Encargado de cargar las ventanas que tienen redireccionamiento*/
    #cards a {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      text-align: center;
      color: rgb(126,127,116);;
      width: 100%;
      /* border: 1px solid #222222;
      border: 1px solid rgba(0,117,115,0.9); */
      border-radius: 8px;
      padding-top: 10px;
      position: relative;
      border: none;
    }

      #cards a:hover {
        text-decoration: none;
        background-color: rgba(255,255,255,0.2);
        background-color: rgba(0,117,115,0.9);
        border: 1px solid #AAA;
        box-sizing: border-box;
        color: white;
      }

        #cards a:hover span {
          display: block;
          position: absolute;
          left: 0;
          right: 0;
          top: 53%;
        }
</style>



// WEBPACK FOOTER //
// src/components/Tablero/SistemasWeb.vue